import CloseIcon from '@mui/icons-material/Close'
import { Button, IconButton, Modal, Slide } from '@mui/material'
import _ from 'lodash'
import React, { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import styles from './ProductFilterDesktopModal.module.scss'
import { THEMED_QUERY_SELECTOR } from '../../../../interfaces/AppInterface'
import { ActiveFiltersInterface, ProductFiltersInterface } from '../../../../interfaces/FiltersInterface'
import ProductFilterList from '../../ProductFilterList/ProductFilterList'

interface Props {
  open: boolean
  filters: ProductFiltersInterface
  activeFilters: ActiveFiltersInterface
  onFlatAttributeChange: (name: string, valueId: number | string, checked: boolean) => void
  onAttributeChange: (attributeId: number, valueId: number, checked: boolean) => void
  onRangeChanged: (attributeId: string, minValue: string | null, maxValue: string | null, extra?: object) => void
  clearFilters: () => void
  onClose: () => void
}

const ProductFilterDesktopModal: React.FC<Props> = (props: Props) => {
  const [modalContainer, setModalContainer] = useState<Element | null>(null)

  useEffect(() => {
    setModalContainer(document.querySelector(THEMED_QUERY_SELECTOR))
  }, [])

  return (
    <Modal
      open={props.open}
      onClose={props.onClose}
      container={modalContainer}
      slotProps={{ backdrop: { className: styles['product-filter-desktop-modal__backdrop'] } }}
    >
      <Slide direction="right" in={props.open} mountOnEnter unmountOnExit timeout={500}>
        <div className={styles['product-filter-desktop-modal__container']}>
          <div className={styles['product-filter-desktop-modal__filter-list']}>
            <div className={styles['filter-list__header']}>
              <FormattedMessage id="ProductFilter.Modal.Header" defaultMessage="Filters" />
              <div className={styles['header__close-button__container']}>
                <IconButton className={styles['filter-list__header__close-button']} onClick={props.onClose}>
                  <CloseIcon />
                </IconButton>
              </div>
            </div>
            <div className={styles['filter-list__content']}>
              <ProductFilterList
                filters={props.filters}
                activeFilters={props.activeFilters}
                onFlatAttributeChange={props.onFlatAttributeChange}
                onAttributeChange={props.onAttributeChange}
                onRangeChanged={props.onRangeChanged}
              />
            </div>
            <div className={styles['filter-list__footer']}>
              <Button variant="outlined" className={styles['filter-list__footer__button']} onClick={props.clearFilters}>
                <FormattedMessage id="ProductFilter.Modal.Clear" defaultMessage="Clear all" />
              </Button>
              <Button variant="contained" className={styles['filter-list__footer__button']} onClick={props.onClose}>
                <FormattedMessage id="ProductFilter.Modal.Apply" defaultMessage="Apply" />
              </Button>
            </div>
          </div>
        </div>
      </Slide>
    </Modal>
  )
}

export default ProductFilterDesktopModal
